import React from 'react';
import { motion } from 'framer-motion';
import { CtaShimmer } from './CtaShimmer';
import { Zap, Check, Lock, Mail, Shield, RefreshCw } from 'lucide-react';
const pack = {
  id: 'megakit',
  icon: <Zap className="text-navy w-6 h-6 md:w-8 md:h-8" data-id="element-176" />,
  title: 'MEGA KIT ELECTRICISTA PRO™',
  subtitle: 'La biblioteca técnica profesional más completa para aprender, consultar, instalar, reparar y presupuestar con más seguridad.',
  savings: '80% DE DESCUENTO SOLO POR HOY',
  features: ['✅ 5 Tomos Maestros + 5 Bonos Estratégicos', '✅ 100+ Videos Máster', '✅ 150+ Diagramas PRO', '✅ Guía Industrial Avanzada', '✅ Manual de Energía Solar', '✅ Acceso digital inmediato', '✅ Garantía de 7 días'],
  oldPrice: 'USD 95.00',
  price: 'USD 19.00',
  url: 'https://mega-kit-electricistapro.impultienda.ar/checkout'
};
export function Pricing() {
  const handlePurchase = () => {
    window.location.href = pack.url;
  };
  return <section id="pricing" className="py-12 md:py-24 px-4 max-w-5xl mx-auto min-h-[100dvh] flex flex-col justify-center relative" data-id="element-177">
      <div className="text-center mb-10 md:mb-16" data-id="element-178">
        
        <p className="text-slate-600 font-bold text-sm md:text-xl bg-white inline-block px-6 py-2 rounded border border-slate-200 shadow-sm" data-id="element-179">
          Una sola oferta de lanzamiento. Acceso digital inmediato.
        </p>
      </div>

      <div className="mb-6 md:mb-16" data-id="element-180">
        <motion.div className="p-4 md:p-10 rounded border-2 border-slate-200 bg-white shadow-xl relative overflow-hidden" data-id="element-181">
          <div className="flex flex-col md:flex-row gap-5 md:gap-12" data-id="element-182">
            <div className="flex-1" data-id="element-183">
              <div className="flex flex-wrap gap-2 mb-3 md:mb-4" data-id="element-184">
                <span className="bg-electric text-navy text-[10px] md:text-xs font-black px-3 py-1 rounded uppercase tracking-widest shadow-sm" data-id="element-185">
                  {pack.savings}
                </span>
              </div>
              <div className="flex items-center gap-3 mb-3 md:mb-4" data-id="element-186">
                <div className="bg-electric p-2 md:p-3 rounded shadow-inner" data-id="element-187">
                  {pack.icon}
                </div>
                <h3 className="font-black text-navy text-lg md:text-3xl uppercase leading-tight" data-id="element-188">
                  {pack.title}
                </h3>
              </div>
              <p className="text-slate-600 font-semibold text-sm md:text-lg mb-4 md:mb-8 bg-slate-50 p-3 md:p-4 rounded border border-slate-200" data-id="element-189">
                {pack.subtitle}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mb-4 md:mb-8" data-id="element-190">
                {pack.features.map((f, i) => <div key={i} className="flex items-start gap-2 text-sm md:text-base text-slate-700 font-semibold leading-tight bg-white p-1.5 md:p-2 rounded" data-id="element-191">
                    {!f.startsWith('✅') && <Check size={16} className="text-electric shrink-0 mt-0.5" data-id="element-192" />}
                    <span data-id="element-193">{f.replace('✅ ', '⚡ ')}</span>
                  </div>)}
              </div>
            </div>

            <div className="md:w-80 shrink-0 flex flex-col justify-center bg-navy p-5 md:p-8 rounded border-t-4 border-electric text-center text-white" data-id="element-194">
              <div className="mb-4 md:mb-6" data-id="element-195">
                <span className="text-slate-400 line-through font-bold text-lg md:text-2xl block mb-1 md:mb-2" data-id="element-196">
                  {pack.oldPrice}
                </span>
                <span className="text-4xl md:text-6xl font-black text-electric drop-shadow-sm bg-black/20 px-4 py-2 rounded inline-block" data-id="element-197">
                  {pack.price}
                </span>
              </div>

              <motion.button animate={{
              y: [0, -3, 0],
              boxShadow: ['0 6px 0 rgb(200,160,0), 0 0 0px rgba(255,210,0,0)', '0 6px 0 rgb(200,160,0), 0 0 22px rgba(255,210,0,0.55)', '0 6px 0 rgb(200,160,0), 0 0 0px rgba(255,210,0,0)']
            }} transition={{
              duration: 2.6,
              repeat: Infinity,
              ease: 'easeInOut'
            }} whileHover={{
              scale: 1.03,
              boxShadow: '0 6px 0 rgb(200,160,0), 0 0 34px rgba(255,210,0,0.75)'
            }} whileTap={{
              scale: 0.98
            }} onClick={handlePurchase} className="relative overflow-hidden w-full bg-electric hover:bg-yellow-400 text-navy font-black text-lg md:text-xl py-4 md:py-5 rounded transition-colors mb-3 md:mb-4 uppercase tracking-tight" data-id="element-198">
                <CtaShimmer data-id="element-199" />
                <span className="relative z-10" data-id="element-200">⚡ ACCEDER AL MEGA KIT</span>
              </motion.button>

              <p className="text-slate-300 text-[10px] md:text-xs font-semibold uppercase tracking-widest" data-id="element-201">
                Pago seguro • Acceso inmediato
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="text-center mb-8" data-id="element-202">
        <h3 className="text-navy font-black text-lg md:text-xl mb-3" data-id="element-203">
          PAGO SEGURO Y PROTEGIDO
        </h3>
        <p className="text-slate-600 font-medium text-sm md:text-base max-w-3xl mx-auto bg-white p-4 rounded border border-slate-200" data-id="element-204">
          🔒 Compra segura. El precio está expresado en dólares estadounidenses.
          Al ingresar al checkout, la plataforma mostrará automáticamente la
          conversión a tu moneda local. Una vez confirmado el pago, recibirás el
          acceso digital por correo electrónico.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-205">
        {[{
        icon: <Lock data-id="element-206" />,
        title: 'PAGO SEGURO',
        desc: 'Pasarela encriptada'
      }, {
        icon: <Mail data-id="element-207" />,
        title: 'ENTREGA DIGITAL',
        desc: 'Acceso inmediato'
      }, {
        icon: <Shield data-id="element-208" />,
        title: 'GARANTÍA 7 DÍAS',
        desc: 'Compra sin riesgo'
      }, {
        icon: <RefreshCw data-id="element-209" />,
        title: 'CONVERSIÓN',
        desc: 'A moneda local'
      }].map((badge, i) => <div key={i} className="bg-white p-6 rounded border border-slate-200 text-center flex flex-col items-center hover:-translate-y-1 transition-transform shadow-sm" data-id="element-210">
            <div className="bg-slate-100 text-navy p-3 rounded mb-4" data-id="element-211">
              {badge.icon}
            </div>
            <p className="font-black text-navy text-xs md:text-sm mb-2" data-id="element-212">
              {badge.title}
            </p>
            <p className="text-slate-500 text-[10px] md:text-xs font-semibold" data-id="element-213">
              {badge.desc}
            </p>
          </div>)}
      </div>

      <div className="bg-navy p-8 md:p-12 rounded border-l-4 border-electric flex flex-col md:flex-row items-center gap-8 text-center md:text-left shadow-xl" data-id="element-214">
        <div className="shrink-0 bg-white p-4 rounded transform -rotate-3" data-id="element-215">
          <img src="https://cdn.magicpatterns.com/uploads/wPdBTd5Jo7F4dpjLi12DAp/garantia-7-dias-250.webp" alt="Garantía 7 días" className="w-24 h-auto md:w-32" data-id="element-216" />
        </div>
        <div data-id="element-217">
          <h5 className="text-white font-black text-2xl md:text-3xl mb-3" data-id="element-218">
            Garantía de satisfacción de 7 días
          </h5>
          <p className="text-slate-300 font-medium text-base md:text-lg leading-relaxed" data-id="element-219">
            Explora el material con tranquilidad. Si consideras que el MEGA KIT
            ELECTRICISTA PRO™ no es adecuado para tus necesidades, puedes
            solicitar la devolución dentro de los 7 días posteriores a la
            compra.
          </p>
        </div>
      </div>
    </section>;
}